import { differenceInDays, isAfter, isBefore, isSameDay, subMonths } from 'date-fns';
import { DateRangeType } from 'enums';

export type DateRange = {
    startDate: Date;
    endDate: Date;
};

export const dateRangeToDates = (dateRange: DateRangeType) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const months = dateRangeToMonths(dateRange);

    return {
        startDate: subMonths(today, months),
        endDate: today
    };
};

export const dateRangeToDays = (dateRange: DateRangeType) => {
    const { startDate, endDate } = dateRangeToDates(dateRange);
    return differenceInDays(endDate, startDate);
};

export const dateRangeToMonths = (dateRange: DateRangeType) => {
    switch (dateRange) {
        case DateRangeType.ThreeMonths: return 3;
        case DateRangeType.SixMonths: return 6;
        case DateRangeType.OneYear: return 12;
    }
};

export const isDateBetween = (startDate: Date, endDate: Date, date?: Date) => date
    && (isSameDay(date, startDate) || isAfter(date, startDate))
    && (isSameDay(date, endDate) || isBefore(date, endDate));

export const isDateInRange = (dateRange: DateRangeType, date?: Date) => {
    const { startDate, endDate } = dateRangeToDates(dateRange);
    return isDateBetween(startDate, endDate, date);
};